function getWeekNr(date) {
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const dag = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - dag);
  const jaarStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  return Math.ceil((((d - jaarStart) / 86400000) + 1) / 7);
}

// "W38" — compact weeknummer
export function weekLabel(datumStr) {
  if (!datumStr) return '—';
  const d = new Date(datumStr);
  if (isNaN(d)) return '—';
  return `W${getWeekNr(d)}`;
}

// "W38 · 14 sep" — weeknummer met korte datum
export function weekMetDatum(datumStr) {
  if (!datumStr) return '—';
  const d = new Date(datumStr);
  if (isNaN(d)) return '—';
  const dag = d.toLocaleDateString('nl-BE', { day: 'numeric', month: 'short' });
  return `W${getWeekNr(d)} · ${dag}`;
}

// Volledige datum voor tooltip of detail: "ma 14 sep 2026"
export function volledigeDatum(datumStr) {
  if (!datumStr) return '';
  const d = new Date(datumStr);
  if (isNaN(d)) return '';
  return d.toLocaleDateString('nl-BE', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' });
}

// Korte datum voor invoervelden: "2026-09-14"
export function datumInput(datumStr) {
  if (!datumStr) return '';
  return new Date(datumStr).toISOString().split('T')[0];
}
